import(/* webpackMode: "eager" */ "/var/www/front/live/eduvalu-front/app/courses/CoursesPage.tsx")